import React, { createContext, useContext, useEffect, useState } from 'react';
import { supabase } from '../supabaseClient';

const SylloContext = createContext();

export const useSyllo = () => {
  return useContext(SylloContext);
};

export const SylloProvider = ({ children }) => {
  const [puzzles, setPuzzles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchPuzzles = async () => {
      try {
        const { data: puzzlesData, error: puzzlesError } = await supabase
          .from('syllo_puzzles')
          .select(`
            date,
            title,
            syllo_clues (
              id,
              number,
              answer,
              hint_1,
              hint_2,
              hint_3,
              slug,
              clue_text
            )
          `)
          .order('date', { ascending: false });

        if (puzzlesError) throw puzzlesError;

        if (puzzlesData && puzzlesData.length > 0) {
          const formattedPuzzles = puzzlesData.map(puzzle => {
            const sortedClues = puzzle.syllo_clues
              ? puzzle.syllo_clues
                  .sort((a, b) => a.number - b.number)
                  .map(c => ({
                    ...c,
                    text: c.clue_text // Map clue_text to text for compatibility
                  }))
              : [];
            
            return {
              date: puzzle.date,
              title: puzzle.title,
              puzzleNumber: puzzle.title.match(/#(\d+)/) ? puzzle.title.match(/#(\d+)/)[1] : null,
              clues: sortedClues
            };
          });
          setPuzzles(formattedPuzzles);
        } else {
           setPuzzles([]);
        }
      } catch (err) {
        console.error('Error fetching syllo puzzles:', err);
        setError(err.message);
        setPuzzles([]);
      } finally {
        setLoading(false);
      }
    };

    fetchPuzzles();
  }, []);

  const value = {
    puzzles,
    loading,
    error
  };

  return (
    <SylloContext.Provider value={value}>
      {children}
    </SylloContext.Provider>
  );
};

